import useSWR from 'swr';

import { BillingInvoiceHelper } from './billing-invoice-helper';
import { downloadInvoice } from './downloadInvoice';
import type { InvoiceDownloadResponse, InvoiceRequest } from './types';

export function useInvoiceDownload(request: Readonly<InvoiceRequest>) {
  const url = BillingInvoiceHelper.invoiceUrl(request, 'download');
  return useSWR<InvoiceDownloadResponse>(
    request.companyId && request.invoiceId ? url : null,
    () => downloadInvoice(request)
  );
}
